<template>
  <div class="UploadCard">
    <div  class="UploadCard-header"
         :class="'UploadCard-header--' + state">
      <div class="UploadCard-thumbnail">
        <img src='/assets/icons/map.png'>
      </div>

      <div class="UploadCard-caption">
        <div class="UploadCard-title">
          <div class="UploadCard-filename">
            <!-- <i
              class="fas fa-exclamation ml5"
              v-tooltip="'' + error"
              v-if="state === states.error"></i> -->
            {{ file.name }}
          </div>

          <router-link  class="UploadCard-details"
                       :to="'/games/' + replay.id"
                        v-if="replay">Details</router-link>
        </div>

        <div class="UploadCard-size">
          {{ filesize }}
        </div>

        <div class="UploadCard-progress">
          <Bar :fill="progress"></Bar>
        </div>
      </div>
    </div>

    <Collapser class="UploadCard-body" v-if="state === states.uploaded">
      <Table>
        <tbody>
          <tr v-for="player in replay.data.game.players">
            <td>
              <Block :colour="player.colour"></Block>
            </td>
            <td>{{ player.name }}</td>
            <td>{{ time (player.leftAt) }}</td>
          </tr>
        </tbody>
      </Table>
    </Collapser>

    <div class="UploadCard-body UploadCard-error" v-else-if="state === states.error">
      Upload Error: {{ error }}
    </div>
  </div>
</template>

<script>
  import Api from '@/legacy/lib//Api';
  import Bar from '@/legacy/components/widgets/Bar';
  import Collapser from '@/legacy/components/widgets/Collapser';
  import Table from '@/legacy/components/widgets/Table.vue';
  import Block from '@/legacy/components/widgets/Block';

  import { filesize, time, httpBuildQuery } from '@/legacy/lib//util';
  import { rgba } from '@/legacy/lib//template';

  export default {
    components: {
      Bar,
      Table,
      Collapser,
      Block
    },

    props: {
      file: {
        type: File
      }
    },

    methods: {
      time,
      rgba
    },

    data: function () {
      return {
        state: 0x01,

        states: {
          uploading: 0x01,
          parsing:   0x02,
          uploaded:  0x04,
          error:     0x08
        },

        /** **/

        progress: 0,

        filesize: filesize (this.file.size),

        replay: null,

        error: null

        // Populated when the replay is successfully parsed for the info tables.
        // players: []
      };
    },

    mounted: function () {
      let self = this,
          interval;

      Api.upload (
        httpBuildQuery (
          '/upload'
        ),

        this.file,

        (progress) => {
          // Only want the first quarter of the progress bar to indicate file upload.
          self.progress = progress / 4;

          if (progress === 100) {
            self.state = self.states.parsing;

            // We don't know how long the parsing is going to take but the progress
            // bar should keep moving so we will increment every half second.
            interval = setInterval (() => {
              self.progress = Math.min (
                self.progress + 2,
                100
              );
            }, 250);
          }
        }
      )

      .then ((xhr) => {
        let data;

        clearInterval (interval);

        self.state    = self.states.uploaded;
        self.progress = 100;

        try {
          data = JSON.parse (xhr.response);
          this.replay = data.body;
        } catch (e) {
          self.state = self.states.error;
          self.error = "Illegal API Response";
        }
      })

      .catch ((xhr) => {
        let data;

        self.progress = 100;
        self.state = self.states.error;

        try {
          data = JSON.parse (xhr.response);
          self.error = data.error;
        } catch (e) {
          self.error = "Illegal API Response";
        }
      });
    }
  }
</script>

<style lang="scss">
  .UploadCard {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    padding: 0 !important;

    border: 1px solid rgba(var(--white), .1);

    &-header {
      display: flex;
      flex-direction: row;
      max-width: 100%;
      transition: color 1s ease;

      // Box shadow changed based on state.
      box-shadow: inset 0 0 50px rgba(var(--black), .1);

      .W3S-bar {
        position: static;
      }

      // &--1 .Bar-fill { background: linear-gradient(rgba(var(--black), .8), rgba(var(--orange), .8)) !important; }
      // &--2 .Bar-fill { background: linear-gradient(rgba(var(--black), .8), rgba(var(--yellow), .8)) !important; }
      // &--4 .Bar-fill { background: linear-gradient(rgba(var(--black), .8), rgba(var(--green), .8))  !important; }
      &--8 .Bar-fill { background: linear-gradient(rgba(var(--black), .8), rgba(var(--red), 1))    !important; }
    }

    &-thumbnail {
      height: 80px;
      margin: 0;
      padding: 8px;
      min-width: 80px;
      max-width: 80px;
    }

    &-caption {
      overflow: hidden;

      flex-grow: 1;
      padding: 8px 12px;
    }

    &-title {
      display: flex;

      color: rgba(var(--tan), 1);
      font-size: 18px;
    }

    &-filename {
      @include ellipsis;
    }

    &-details {
      flex-grow: 1;
      margin-right: 6px;
      padding: 0;

      // font-size: 0.85em;
      text-align: right;
    }

    &-size {
      color: rgba(var(--sand), 1);
    }

    &-progress {
      position: relative;

      margin: 12px 10px 0 -5px;

      white-space: nowrap;
    }

    &-body {
      font-size: 18px;
    }

    &-error {
      border-top: fetch(border faint);
      padding: 8px;
      color: rgba(var(--red), 0.8);
    }

    .Block {
      margin-top: 5px;
    }
  }
</style>